import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import { MaterialModule } from '../../../../material/material.module';

@Component({
  selector: 'app-agency-edit-action-for-etb',
  standalone: true,
  imports: [MaterialModule],
  template: `
    <span (click)="navigateToEditEstablishment()"
          class="cursor-pointer text-action">
      Modifier
    </span>
  `,
  styles: ['.text-action { color: #0066CC; }']
})
export class AgencyEditActionForEtbComponent implements OnInit{
  @Input() data: any = undefined;
  @Input() column: any = undefined;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToEditEstablishment = () => {
    if (this.data && this.data.id) {
      this.router.navigate([`/agency/establishment/edit/${this.data.id}`]);
    }
  }
}